import { I18n } from "@/i18n/I18n";

export function CompleteState() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-label={I18n.get('completed')}>
    <path fill="#8BC34A" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.59L5.41 11 7 9.41l3 3 7-7L18.59 7 10 15.59z"/>
  </svg>
  );
}
